import { registerMicroApps } from 'qiankun'
import * as apis from '../apis'

export const apps = [
  // 采编发中心-设置
  {
    name: 'module-config',
    container: '#container',
    activeRule: '/service/mediacloud-config',
    props: {
      routeBase: '/service/mediacloud-config'
    }
  },
  // // 模板微应用
  // {
  //   name: 'mediacloud-template',
  //   container: '#container',
  //   activeRule: '/service/mediacloud-template',
  //   props: {
  //     routeBase: '/service/mediacloud-template'
  //   }
  // },
  //  导航配置
  {
    name: 'module-main-manage',
    container: '#container',
    activeRule: '/service/main-manage',
    props: {
      routeBase: '/service/main-manage'
    }
  },
  // 内容发布
  {
    name: 'module-publish-center',
    container: '#container',
    activeRule: '/service/mediacloud-publish-center',
    props: {
      routeBase: '/service/mediacloud-publish-center'
    }
  },
  {
    name: 'module-publish-center-open',
    container: '#container',
    activeRule: '/open/mediacloud-publish-center',
    props: {
      routeBase: '/open/mediacloud-publish-center'
    }
  },
  // 系统管理
  {
    name: 'module-system',
    container: '#container',
    activeRule: '/service/mediacloud-system',
    props: {
      routeBase: '/service/mediacloud-system'
    }
  },
  // 资源中心图片库
  {
    name: 'module-resource-photo',
    container: '#container',
    activeRule: '/service/resource-center-photos',
    props: {
      routeBase: '/service/resource-center-photos'
    }
  },
  {
    name: 'module-resource-photo-open',
    container: '#container',
    activeRule: '/open/resource-center-photos',
    props: {
      routeBase: '/open/resource-center-photos'
    }
  },
  // 报纸设置
  {
    name: 'module-paper-manage',
    container: '#container',
    activeRule: '/service/mediacloud-paper-manage',
    props: {
      routeBase: '/service/mediacloud-paper-manage'
    }
  },
  {
    name: 'module-paper-manage-open',
    container: '#container',
    activeRule: '/open/mediacloud-paper-manage',
    props: {
      routeBase: '/open/mediacloud-paper-manage'
    }
  },
  {
    name: 'module-paper',
    container: '#container',
    activeRule: '/service/mediacloud-paper',
    props: {
      routeBase: '/service/mediacloud-paper'
    }
  },
  {
    name: 'module-paper-open',
    container: '#container',
    activeRule: '/open/mediacloud-paper',
    props: {
      routeBase: '/open/mediacloud-paper'
    }
  },
  {
    // 期刊
    name: 'module-journal',
    container: '#container',
    activeRule: '/service/mediacloud-journal',
    props: {
      routeBase: '/service/mediacloud-journal'
    }
  },
  {
    name: 'module-journal-open',
    container: '#container',
    activeRule: '/open/mediacloud-journal',
    props: {
      routeBase: '/open/mediacloud-journal'
    }
  },
  {
    name: 'module-release-end',
    container: '#container',
    activeRule: '/service/mediacloud-release-end',
    props: {
      routeBase: '/service/mediacloud-release-end'
    }
  },
  {
    name: 'module-release-end-open',
    container: '#container',
    activeRule: '/open/mediacloud-release-end',
    props: {
      routeBase: '/open/mediacloud-release-end'
    }
  },
  // 会员管理
  {
    name: 'module-member-web',
    container: '#container',
    activeRule: '/service/module-member-web',
    props: {
      routeBase: '/service/module-member-web'
    }
  },
  {
    name: 'module-member-web-open',
    container: '#container',
    activeRule: '/open/module-member-web',
    props: {
      routeBase: '/open/module-member-web'
    }
  },
  {
    name: 'module-prodb',
    container: '#container',
    activeRule: '/service/module-prodb',
    props: {
      routeBase: '/service/module-prodb'
    }
  },
  {
    name: 'module-article-edit',
    container: '#container',
    activeRule: '/service/mediacloud-article-edit',
    props: {
      routeBase: '/service/mediacloud-article-edit'
    }
  },
  {
    name: 'module-article-edit-open',
    container: '#container',
    activeRule: '/open/mediacloud-article-edit',
    props: {
      routeBase: '/open/mediacloud-article-edit'
    }
  },
  {
    name: 'module-article-origin',
    container: '#container',
    activeRule: '/service/mediacloud-article-origin',
    props: {
      routeBase: '/service/mediacloud-article-origin'
    }
  },
  {
    name: 'module-article-origin-open',
    container: '#container',
    activeRule: '/open/mediacloud-article-origin',
    props: {
      routeBase: '/open/mediacloud-article-origin'
    }
  },
  {
    name: 'module-article-my',
    container: '#container',
    activeRule: '/service/mediacloud-article-my',
    props: {
      routeBase: '/service/mediacloud-article-my'
    }
  },
  {
    name: 'module-article-my-open',
    container: '#container',
    activeRule: '/open/mediacloud-article-my',
    props: {
      routeBase: '/open/mediacloud-article-my'
    }
  },
  {
    name: 'module-article-wx',
    container: '#container',
    activeRule: '/service/mediacloud-article-wx',
    props: {
      routeBase: '/service/mediacloud-article-wx'
    }
  },
  {
    name: 'module-article-wx-open',
    container: '#container',
    activeRule: '/open/mediacloud-article-wx',
    props: {
      routeBase: '/open/mediacloud-article-wx'
    }
  },
  {
    name: 'module-wire',
    container: '#container',
    activeRule: '/service/mediacloud-wire',
    props: {
      routeBase: '/service/mediacloud-wire'
    }
  },
  {
    name: 'module-wire-open',
    container: '#container',
    activeRule: '/open/mediacloud-wire',
    props: {
      routeBase: '/open/mediacloud-wire'
    }
  },
  // 音视频
  {
    name: 'module-mam',
    container: '#container',
    activeRule: '/service/mediacloud-mam',
    props: {
      routeBase: '/service/mediacloud-mam'
    }
  },
  {
    name: 'module-mam-open',
    container: '#container',
    activeRule: '/open/mediacloud-mam',
    props: {
      routeBase: '/open/mediacloud-mam'
    }
  },
  {
    name: 'module-article-audit',
    container: '#container',
    activeRule: '/service/mediacloud-article-audit',
    props: {
      routeBase: '/service/mediacloud-article-audit'
    }
  },
  {
    name: 'module-article-audit-open',
    container: '#container',
    activeRule: '/open/mediacloud-article-audit',
    props: {
      routeBase: '/open/mediacloud-article-audit'
    }
  },
  // 大数据线索发现
  {
    name: 'module-mbd-track',
    container: '#container',
    activeRule: '/service/mbd-track',
    props: {
      routeBase: '/service/mbd-track'
    }
  },
  // 详情页
  {
    name: 'module-mbd-track-open',
    container: '#container',
    activeRule: '/open/mbd-track',
    props: {
      routeBase: '/open/mbd-track'
    }
  },
  // 大数据配置管理
  {
    name: 'module-mbd-settings',
    container: '#container',
    activeRule: '/service/mbd-settings',
    props: {
      routeBase: '/service/mbd-settings'
    }
  },
  {
    name: 'module-mbd-datacenter',
    container: '#container',
    activeRule: '/service/mbd-etl',
    props: {
      routeBase: '/service/mbd-etl'
    }
  },
  // 见报成品
  {
    name: 'module-rc-paper',
    container: '#container',
    activeRule: '/service/rc-paper',
    props: {
      routeBase: '/service/rc-paper'
    }
  },
  {
    name: 'module-rc-paper-open',
    container: '#container',
    activeRule: '/open/rc-paper',
    props: {
      routeBase: '/open/rc-paper'
    }
  },
  // 专题
  {
    name: 'module-rc-special-topic',
    container: '#container',
    activeRule: '/service/rc-special-topic',
    props: {
      routeBase: '/service/rc-special-topic'
    }
  },
  {
    name: 'module-rc-special-topic-open',
    container: '#container',
    activeRule: '/open/rc-special-topic',
    props: {
      routeBase: '/open/rc-special-topic'
    }
  },
  // 渠道运营
  {
    name: 'module-mbd-behavior',
    container: '#container',
    activeRule: '/service/mbd-behavior',
    props: {
      routeBase: '/service/mbd-behavior'
    }
  },
  {
    name: 'module-mbd-behavior-open',
    container: '#container',
    activeRule: '/open/mbd-behavior',
    props: {
      routeBase: '/open/mbd-behavior'
    }
  },
  // 统一检索
  {
    name: 'module-fts-open',
    container: '#container',
    activeRule: '/open/mediacloud-fts',
    props: {
      routeBase: '/open/mediacloud-fts'
    }
  },
  // 统一检索
  {
    name: 'module-fts',
    container: '#container',
    activeRule: '/service/mediacloud-fts',
    props: {
      routeBase: '/service/mediacloud-fts'
    }
  },
  // 运营中心
  {
    name: 'module-nis',
    container: '#container',
    activeRule: '/service/mediacloud-nis',
    props: {
      routeBase: '/service/mediacloud-nis'
    }
  },
  {
    name: 'module-nis-open',
    container: '#container',
    activeRule: '/open/mediacloud-nis',
    props: {
      routeBase: '/open/mediacloud-nis'
    }
  },
  // 抖音快手bilibili 头条百家企鹅
  {
    name: 'module-video-portal',
    container: '#container',
    activeRule: '/service/mediacloud-article-video',
    props: {
      routeBase: '/service/mediacloud-article-video'
    }
  },
  // 抖音快手bilibili 头条百家企鹅
  {
    name: 'module-video-portal-open',
    container: '#container',
    activeRule: '/open/mediacloud-article-video',
    props: {
      routeBase: '/open/mediacloud-article-video'
    }
  },
  // 新媒体成品
  {
    name: 'module-mbd-article',
    container: '#container',
    activeRule: '/service/mbd-article-finished',
    props: {
      routeBase: '/service/mbd-article-finished'
    }
  },
  // 新媒体成品
  {
    name: 'module-mbd-article-open',
    container: '#container',
    activeRule: '/open/mbd-article-finished',
    props: {
      routeBase: '/open/mbd-article-finished'
    }
  },
  // 数据分析
  {
    name: 'module-datanalysis',
    container: '#container',
    activeRule: '/service/mediacloud-datanalysis',
    props: {
      routeBase: '/service/mediacloud-datanalysis'
    }
  },
  {
    name: 'module-datanalysis-open',
    container: '#container',
    activeRule: '/open/mediacloud-datanalysis',
    props: {
      routeBase: '/open/mediacloud-datanalysis'
    }
  },
  // 选题策划
  {
    name: 'module-newsplan',
    container: '#container',
    activeRule: '/service/mediacloud-newsplan',
    props: {
      routeBase: '/service/mediacloud-newsplan'
    }
  },
  {
    name: 'module-newsplan-open',
    container: '#container',
    activeRule: '/open/mediacloud-newsplan',
    props: {
      routeBase: '/open/mediacloud-newsplan'
    }
  },
  // 区划管理
  {
    name: 'module-distinct',
    container: '#container',
    activeRule: '/service/mediacloud-distinct',
    props: {
      routeBase: '/service/mediacloud-distinct'
    }
  },
  {
    name: 'module-distinct-open',
    container: '#container',
    activeRule: '/open/mediacloud-distinct',
    props: {
      routeBase: '/open/mediacloud-distinct'
    }
  },
  // // 音视频-系统管理
  // {
  //   name: 'mediacloud-mam-admin',
  //   container: '#container',
  //   activeRule: '/service/mediacloud-mam-admin',
  //   props: {
  //     routeBase: '/service/mediacloud-mam-admin'
  //   }
  // },
  // // 采编发中心-管理中心
  // {
  //   name: 'mediacloud-manage-center',
  //   container: '#container',
  //   activeRule: '/service/mediacloud-manage-center',
  //   props: {
  //     routeBase: '/service/mediacloud-manage-center'
  //   }
  // }
  {
    name: 'module-reporter',
    container: '#container',
    activeRule: '/service/mediacloud-reporter',
    props: {
      routeBase: '/service/mediacloud-reporter'
    }
  },
  {
    name: 'module-reporter-open',
    container: '#container',
    activeRule: '/open/mediacloud-reporter',
    props: {
      routeBase: '/open/mediacloud-reporter'
    }
  },
  {
    name: 'module-production-source',
    container: '#container',
    activeRule: '/service/mediacloud-production-source',
    props: {
      routeBase: '/service/mediacloud-production-source'
    }
  },
  {
    name: 'module-production-source-open',
    container: '#container',
    activeRule: '/open/mediacloud-production-source',
    props: {
      routeBase: '/open/mediacloud-production-source'
    }
  },
  {
    name: 'module-expert-tank',
    container: '#container',
    activeRule: '/service/mediacloud-expert-tank',
    props: {
      routeBase: '/service/mediacloud-expert-tank'
    }
  },
  {
    name: 'module-expert-tank-open',
    container: '#container',
    activeRule: '/open/mediacloud-expert-tank',
    props: {
      routeBase: '/open/mediacloud-expert-tank'
    }
  }
]

/**
 * 注册子应用
 * @param module 公用的vuex-module,可动态注册到子应用的store里
 * @param store 主应用的store对象，貌似没用到。。。
 * @param resetApps 配置信息：修改微应用服务入口
 */
// TODO 启动微服务。这一点数据剥离的就很赞 -yb
export function register(module, store, resetApps) {
  apps.forEach((app) => {
    // console.log(process.env.MODE)
    app.props['module'] = module
    app.props['moduleName'] = app.name
    app.props['envMode'] = process.env.MODE
  })
  const options = setEntries(apps, resetApps)
  registerMicroApps(options, {
    beforeLoad: async (app) => {
      //云雀中自动登录到云端稿库
      if (
        process.env.MODE !== 'RR' &&
        (app.name === 'module-distinct' || app.name === 'module-distinct-open')
      ) {
        let rrLoginInfo = localStorage.getItem('rrLoginUserInfo')
        if (!rrLoginInfo) {
          let checkSum = await apis.MediaCloudGateway.getAutologinChecksum()
          let autoLogin = await apis.MediaCloudGateway.postAutoLogin({
            headers: {
              'Content-Type': 'text/html'
            },
            originDomain: window.PROJECT_CONFIG.MEDIARR_CORE || '',
            data: checkSum.data.data.checksum,
            closeErrorMsg: true
          })
          if (autoLogin.data.status === 0) {
            localStorage.setItem(
              'rrLoginUserInfo',
              JSON.stringify(autoLogin.data.data)
            )
          }
        }
      }
      return Promise.resolve()
    },
    afterMount() {}
  })
  // TODO ES6新方法。将对象进行冻结。 -yb
  // 禁止apps被改变了
  Object.freeze(apps)
}

/**
 * 设置微应用的服务入口
 * 配置文件在 main 工程的 "public/js/config.js" 下
 * 本地服务使用 PROJECT_CONFIG.MICRO_APP_URL.local 对象
 * 发布到环境上之后由 main 工程下 "ci/nginx/bin/entrypoint.sh" 脚本改写config.js文件
 * 本地调试子应用可在sessionStorage里面添加以'debug_'为前缀的微应用名称映射到本地的子应用服务地址
 * 微应用entry读取优先级： `debug_${MICRO_NAME}` > resetApps参数 > 配置文件
 * @param apps 微应用注册表
 * @param resetApps 预留配置参数，在主应用里修改微应用映射地址
 * @returns {*} 设置过entry的微应用注册表
 */
function setEntries(apps, resetApps) {
  /**
   */
  const ENTRIES = window.PROJECT_CONFIG.MICRO_APP_URL
  const entries = ENTRIES[window.__micro__env__] || ENTRIES['local']

  return apps.map((item) => {
    if (!entries[item.name]) {
      console.warn(item.name + ' 服务的地址没有配置！')
    } else if (item.name === 'module-publish-center') {
      // console.log('看看谁在划水不更新', '04051703')
    } else if (
      (item.name === 'module-distinct-open' ||
        item.name === 'module-distinct') &&
      process.env.MODE !== 'RR' &&
      entries[item.name].indexOf('http:') === -1
    ) {
      let names = entries[item.name].split('-')
      let entriesType = names[1].split('.')
      entriesType[0] = 'mediarr'
      names[1] = entriesType.join('.')
      entries[item.name] = names.join('-')
      // console.log(item.name, entries[item.name])
    }
    const debugEntry = sessionStorage.getItem('debug_' + item.name)
    return {
      ...item,
      entry: debugEntry || resetApps[item.name] || entries[item.name]
    }
  })
}
